import {
  SYNC_ARCHIVIO,
  SYNC_ARCHIVIO_PROGRESS,
  SYNC_ARCHIVIO_SUCCESS,
  SYNC_ARCHIVIO_FAIL,
  ARCHIVIO_LOCAL_CHANGED,
} from "./actionTypes"

// tipo: "ordini" | "offerte"
export const syncArchivio = (tipo, forceFull = false) => ({
  type: SYNC_ARCHIVIO,
  payload: { tipo, forceFull },
})

export const syncArchivioProgress = (tipo, count) => ({
  type: SYNC_ARCHIVIO_PROGRESS,
  payload: { tipo, count },
})

export const syncArchivioSuccess = (tipo, count, lastSync) => ({
  type: SYNC_ARCHIVIO_SUCCESS,
  payload: { tipo, count, lastSync },
})

export const syncArchivioFail = (tipo, error) => ({
  type: SYNC_ARCHIVIO_FAIL,
  payload: { tipo, error },
})

// I record in cache sono stati modificati localmente: le pagine devono rileggerli
export const archivioLocalChanged = tipo => ({
  type: ARCHIVIO_LOCAL_CHANGED,
  payload: { tipo },
})
